// 详情里面有上一页/下一页，需要存储起来
export const NEWS_INFO = 'NEWS_INFO'